import { CartAnalyticsOverrides } from '../../../common/constants/anayltics.constants';
import { OrderType } from '../../../common/constants/order-types';
import { StoreState } from '../../../store/store.interface';
import { getCartType } from './store/shop-cart.selectors';
import { getSharpenPromoAnalyticsFromCart } from '../../upsell/sharpen-upsell-promo.analytics';

/**
 * Returns combined analytics overrides for cart events.
 * Includes the order type and the order flow if applicable.
 * Sharpen promo analytics always take precedence.
 *
 * @param state
 * @param baseOrderType
 */
export function getCartAnalyticsOverrides(
  state: StoreState,
  baseOrderType?: OrderType | string
): CartAnalyticsOverrides {
  return {
    orderType: baseOrderType ?? getCartType(state),
    ...getSharpenPromoAnalyticsFromCart(state),
  };
}
